import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { theme } from "../../theme";

const DialogBox = ({ open, onClose, children , maxWidth = "900px"}) => {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose && onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth={false}
      aria-labelledby="responsive-dialog-title"
      slotProps={{
        paper: {
          sx: {
            borderRadius: "20px",
            backgroundColor: theme.palette.background,
            maxWidth: maxWidth,
            width: { xs: "95%", md: maxWidth },
	    maxHeight: "90vh",
          },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          zIndex: 1300,
          color: (theme) => theme.palette.grey[700],
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ padding: "0px", overflow: "auto" }}>{children}</DialogContent>
    </Dialog>
  );
};

export default DialogBox;

